import { FiPlus } from "react-icons/fi";
import { Action, ActionProps } from "../action";
import { forwardRef } from "react";

export const Add = forwardRef<HTMLButtonElement, ActionProps>(
  (props: ActionProps, ref) => {
    return <Action {...props} ref={ref} Icon={FiPlus} variant="default" />;
  }
);
